/* Atelier · About de cero (sep-2026). Solo dos comportamientos: pausar el vídeo de portada y la prenda que
   acompaña al cursor en el índice de colecciones. Todo lo demás es CSS; sin este fichero la página se ve entera. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  function setupHero(root) {
    const video = root.querySelector('.a26-hero-media video');
    const toggle = root.querySelector('[data-a26-toggle]');
    if (!video || !toggle || toggle.dataset.ready) return;
    toggle.dataset.ready = '1';
    const sync = () => { toggle.dataset.state = video.paused ? 'paused' : 'playing'; };
    if (reduce.matches) video.pause();
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    toggle.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); });
    sync();
  }

  function setupIndex(section) {
    const peek = section.querySelector('[data-a26-peek]');
    const rows = section.querySelector('.a26-rows');
    if (!peek || !rows || section.dataset.ready) return;
    section.dataset.ready = '1';
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    let frame = 0, x = 0, y = 0, current = null;
    const place = () => {
      frame = 0;
      const w = peek.offsetWidth, h = peek.offsetHeight;
      const px = Math.min(innerWidth - w - 16, x + 28);
      const py = Math.max(16, Math.min(innerHeight - h - 16, y - h / 2));
      peek.style.setProperty('--x', `${px}px`);
      peek.style.setProperty('--y', `${py}px`);
    };
    const show = (row) => {
      if (row === current) return;
      current = row;
      const src = row && row.querySelector('.a26-row-thumb img');
      peek.querySelectorAll('img').forEach((img) => img.classList.remove('is-on'));
      if (!src) { peek.classList.remove('is-on'); return; }
      let img = peek.querySelector(`img[data-for="${row.dataset.key}"]`);
      if (!img) {
        img = src.cloneNode();
        img.removeAttribute('loading');
        img.alt = '';
        img.dataset.for = row.dataset.key;
        peek.append(img);
      }
      requestAnimationFrame(() => img.classList.add('is-on'));
      peek.classList.add('is-on');
    };
    rows.querySelectorAll('.a26-row').forEach((row, i) => { row.dataset.key = String(i); });
    rows.addEventListener('pointermove', (e) => {
      if (!fine.matches || e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      if (!frame) frame = requestAnimationFrame(place);
      show(e.target.closest('.a26-row'));
    });
    rows.addEventListener('pointerleave', () => { current = null; peek.classList.remove('is-on'); });
    addEventListener('scroll', () => { if (current) { current = null; peek.classList.remove('is-on'); } }, { passive: true });
  }

  function init(scope = document) {
    scope.querySelectorAll('.a26-hero').forEach(setupHero);
    scope.querySelectorAll('[data-a26-index]').forEach(setupIndex);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
